import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { IAppUserBootstrapState } from './types';

const initState: IAppUserBootstrapState = {
  isLoading: false,
};

function onAppUserBootstrap(state: IAppUserBootstrapState) {
  return { ...state, isLoading: true };
}

function onAppUserBootstrapSuccess(state: IAppUserBootstrapState) {
  return { ...state, isLoading: false };
}

function onAppUserBootstrapError(state: IAppUserBootstrapState) {
  return { ...state, isLoading: false };
}

export default createReducer(initState, {
  [actions.APP_USER_BOOTSTRAP]: onAppUserBootstrap,
  [actions.APP_USER_BOOTSTRAP_SUCCESS]: onAppUserBootstrapSuccess,
  [actions.APP_USER_BOOTSTRAP_ERROR]: onAppUserBootstrapError,
});
